<mat-form-field appearance="outline" class="w-full" [subscriptSizing]="subscriptSizing">
  <mat-label>Department {{ required ? "*" : "" }}</mat-label>
  <input
    matInput
    type="text"
    placeholder="Search or select department"
    [disabled]="disabled"
    [(ngModel)]="searchText"
    (ngModelChange)="filterDepartments($event)"
    [matAutocomplete]="auto"
    #autoInput

  />
  <mat-icon matSuffix>search</mat-icon>

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selectDepartment($event.option.value)"
    (opened)="onAutocompleteOpened()"
    panelClass="department-autocomplete-panel"
    [displayWith]="displayDepartment"
  >
    <mat-option *ngFor="let dept of filteredDepartments" [value]="dept">
      {{ dept.viewValue }}
    </mat-option>
    <mat-option
      *ngIf="isLoading"
      class="text-center"
      disabled>
      <div class="w-full text-center">
        <mat-spinner diameter="16" strokeWidth="2" class="inline-block"></mat-spinner>
      </div>
    </mat-option>
    <mat-option
      *ngIf="filteredDepartments.length === 0"
      class="text-center text-gray-400"
      disabled>
      No departments found
    </mat-option>
  </mat-autocomplete>

  <ng-container *ngIf="isLoading && filteredDepartments.length === 0">
    <div matSuffix class="absolute right-5 top-2">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="20"
        strokeWidth="2"
        color="primary">
      </mat-progress-spinner>
    </div>
  </ng-container>

  <mat-error *ngIf="formControl?.hasError('required')">
    Department is required
  </mat-error>
</mat-form-field>
